'use client'
import { cx } from '@/src/styles/stylebook'
import React, { useState } from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

const ListItemsCarousel = ({
  slidesPerView = 4,
  children,
  navigationItems,
  showTitle = false,
  titleItems,
  className,
  breakpoints,
}: {
  slidesPerView?: number
  children: React.ReactNode
  navigationItems?: React.ReactNode
  showTitle?: boolean
  titleItems?: React.ReactNode
  className?: string
  breakpoints?: any
}) => {
  // children을 배열로 변환해서 개수 확인
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  const childrenArray = React.Children.toArray(children)
  const itemCount = childrenArray.length

  // 아이템 개수에 따라 slidesPerView 조정
  const actualSlidesPerView = Math.min(slidesPerView, itemCount)

  // 아이템이 slidesPerView보다 적으면 loop 비활성화
  const shouldLoop = itemCount > slidesPerView

  // 아이템이 없으면 빈 상태 표시
  if (itemCount === 0) {
    return (
      <>
        {showTitle && titleItems}
        {navigationItems}
        <div className={cx('w-full', className)}>
          <div className="flex items-center justify-center py-20 text-gray-400">Empty</div>
        </div>
      </>
    )
  }

  return (
    <>
      {showTitle && titleItems}
      {navigationItems}
      <div className={cx('w-full overflow-hidden px-[calc(var(--spacing-gutter)*0.5)]', className)}>
        <Swiper
          modules={[Navigation]}
          navigation={{
            nextEl: '.list-items-next',
            prevEl: '.list-items-prev',
          }}
          breakpoints={breakpoints}
          slidesPerView={actualSlidesPerView}
          spaceBetween={0}
          direction="horizontal"
          loop={shouldLoop}
          className="list-items-carousel h-full w-full"
          onSlideChange={swiper => {
            setCurrentSlideIndex(swiper.realIndex)
          }}
        >
          {React.Children.map(children, (child, index) => (
            <SwiperSlide
              key={index}
              style={{ width: 'auto' }}
              className={cx(
                'odd:bg-system-tilebg px-[calc(var(--spacing-gutter)*0.5)] pb-50'
                // currentSlideIndex === index ? 'pl-marg' : ''
              )}
            >
              {child}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  )
}

export default ListItemsCarousel
